module.exports = __webpack_public_path__ + "img/space-introduce-5-en.7f05206b.svg";